import FaqInput from "../../components/Recruiting/FAQ/FaqInput";

export default function FaqNew() {
  return <FaqInput />;
}
